<template>
  <div class="card card-carousel overflow-hidden h-100 p-0">
    <div
      id="carouselExampleCaptions"
      class="carousel slide h-100"
      data-bs-ride="carousel"
      ref="carouselRef"
    >
      <div class="carousel-inner border-radius-lg h-100">
        <!-- First slide (video) -->
        <div class="carousel-item h-100 active position-relative" style="background-color: #fff;">
          <div class="video-wrapper">
            <video
              ref="videoRef"
              :src="require('@/assets/img/posvideo.mp4')"
              class="w-100 h-100"
              style="object-fit: contain;"
              playsinline
              muted
              controls
            ></video>
          </div>
        </div>

        <!-- Image slides -->
        <div
          v-for="(slide, i) in slides"
          :key="i"
          class="carousel-item h-100"
          :style="{
            backgroundImage: `url(${require(`@/assets/img/${slide.image}`)})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#ffffff',
          }"
        >
          <div class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5">
            <div class="custom-caption p-4" style="max-width: 460px;">
              <div class="icon icon-shape icon-sm bg-white text-center border-radius-md mb-3">
                <i :class="slide.icon + ' text-dark opacity-10'"></i>
              </div>
              <h5 class="text-dark fw-bold mb-1">{{ slide.title }}</h5>
              <p class="text-dark">{{ slide.text }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Controls -->
      <button class="carousel-control-prev w-5 me-3" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next w-5 me-3" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { Carousel } from "bootstrap";


// Store refs
const videoRef = ref(null);
const carouselRef = ref(null);

// Slides
const slides = [
{
    image: "pos1.png",
    title: "SantimPay POS: Smart Payment Solution",
    text: "Accept payments instantly and securely with our robust POS system, tailored for Ethiopia’s growing market.",
    icon: "ni ni-credit-card",
  },
  {
    image: "pos2.png",
    title: "Flexible Deployment",
    text: "Deploy our solution at shops, markets, or mobile carts—wherever your business goes.",
    icon: "ni ni-delivery-fast",
  },
  {
    image: "pos3.jpg",
    title: "Effortless Integration",
    text: "Connect terminals easily with minimal setup and zero friction to existing systems.",
    icon: "ni ni-laptop",
  },
  {
    image: "pos1.png",
    title: "Real-time Insights",
    text: "Track performance and transactions live with our powerful dashboard.",
    icon: "ni ni-world",
  },
  {
    image: "pos4.jpg",
    title: "Smart Analytics & Reporting",
    text: "Access detailed reports and intelligent analytics to power business decisions.",
    icon: "ni ni-chart-bar-32",
  },
  {
    image: "pos5.jpg",
    title: "Secure & Reliable",
    text: "Built with security in mind. Keep every transaction encrypted and safe.",
    icon: "ni ni-lock-circle-open",
  },
];

// Reset video and play again when it's shown
onMounted(() => {
  const carouselEl = carouselRef.value;
  const carousel = Carousel.getOrCreateInstance(carouselEl);

  if (videoRef.value) {
    // Pause carousel while video is playing
    carousel.pause();

    videoRef.value.addEventListener("ended", () => {
      carousel.next();
      carousel.cycle(); // Resume auto-cycling if needed
    });

    videoRef.value.play().catch(() => {
      videoRef.value.muted = true;
      videoRef.value.play();
    });
  }

  carouselEl.addEventListener("slide.bs.carousel", (e) => {
    if (e.to === 0 && videoRef.value) {
      videoRef.value.currentTime = 0;
      videoRef.value.play().catch(() => {
        videoRef.value.muted = true;
        videoRef.value.play();
      });
      carousel.pause(); // pause while on video
    }

    if (e.from === 0 && videoRef.value) {
      videoRef.value.pause();
      carousel.cycle(); // resume after leaving video
    }
  });
});


</script>

<style scoped>
.custom-caption {
  background: linear-gradient(135deg, #ffeb99ee, #f3f2ede0);
  clip-path: ellipse(100% 100% at 50% 50%);
  border-radius: 40px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.video-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
</style>
